import React from 'react';
import { Link } from 'react-router-dom';

interface LessonItem {
  name: string;
  imageSrc?: string;
  link: string;
}

const lessonItems: LessonItem[] = [
  { name: 'Piano lessons', imageSrc: '/images/piano_1.jpg', link: '/search/piano' },
  { name: 'Guitar lessons', imageSrc: '/images/guitar_1.jpg', link: '/search/guitar' },
  { name: 'Saxophone lessons', imageSrc: '/images/saxophone_1.jpg', link: '/search/saxophone' },
  { name: 'Drum lessons', imageSrc: '/images/drums_1.jpg', link: '/search/drums' },
  { name: 'Violin lessons', imageSrc: '/images/violin_1.jpg', link: '/search/violin' },
  { name: 'Singing lessons', imageSrc: '/images/singing_1.jpg', link: '/search/singing' },
  { name: 'Ukulele lessons', imageSrc: '/images/ukulele_1.jpg', link: '/search/ukulele' },
  { name: 'Bass Guitar lessons', imageSrc: '/images/bass_guitar_1.jpg', link: '/search/bass-guitar' },
];

const LessonCard: React.FC<LessonItem> = ({ name, imageSrc, link }) => {
  console.log('Rendering LessonCard for:', name, "; Image:", imageSrc ? imageSrc : 'None');
  return (
    <Link to={link} className="block group">
      <div className="bg-white rounded-lg shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1">
        {imageSrc && (
          <div className="aspect-w-16 aspect-h-9">
            <img src={imageSrc} alt={name} className="object-cover w-full h-full" />
          </div>
        )}
        <div className={`p-4 ${imageSrc ? 'text-center' : 'flex items-center justify-center h-24'}`}>
          <h3 className={`font-medium ${imageSrc ? 'text-gray-800' : 'text-gray-800 text-lg'}`}>{name}</h3>
        </div>
      </div>
    </Link>
  );
};

const MusicLessons: React.FC = () => {
  console.log('Rendering MusicLessons section');
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900">Music lessons</h2>
          <Link to="/search" className="text-sm font-medium text-lynx-primary hover:text-lynx-dark">
            See all &gt;
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {lessonItems.map((item) => (
            <LessonCard key={item.name} {...item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MusicLessons; 